import { render, staticRenderFns } from "./IconsAction.vue?vue&type=template&id=1a951518&scoped=true"
import script from "./IconsAction.vue?vue&type=script&lang=js"
export * from "./IconsAction.vue?vue&type=script&lang=js"
import style0 from "./IconsAction.vue?vue&type=style&index=0&id=1a951518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a951518",
  null
  
)

export default component.exports